import {EcommerceSettings} from '@wix/wixstores-client-storefront-sdk';

export class EcommerceSettingsModel {
  public hasValidationsInCart: boolean;
  public hasAdditionalFees: boolean;
  public canBusinessShip: boolean;
  public isPremium: boolean;
  public isTaxConfigured: boolean;

  constructor(params: EcommerceSettingsModel) {
    this.hasValidationsInCart = params.hasValidationsInCart;
    this.hasAdditionalFees = params.hasAdditionalFees;
    this.canBusinessShip = params.canBusinessShip;
    this.isPremium = params.isPremium;
    this.isTaxConfigured = params.isTaxConfigured;
  }

  public static fromEcommerceSettings(ecommerceSettings: EcommerceSettings) {
    if (!ecommerceSettings) {
      return new EcommerceSettingsModel({
        hasValidationsInCart: true,
        hasAdditionalFees: true,
        isPremium: true,
        canBusinessShip: true,
        isTaxConfigured: true,
      });
    }

    return new EcommerceSettingsModel({
      hasValidationsInCart: ecommerceSettings.hasValidationsInCart,
      hasAdditionalFees: ecommerceSettings.hasAdditionalFees,
      canBusinessShip: ecommerceSettings.delivery.countries?.length > 0 || !!ecommerceSettings.delivery.restOfWorld,
      isPremium: ecommerceSettings.isPremium,
      isTaxConfigured: ecommerceSettings.tax.configured,
    });
  }
}
